module.exports=function(scope){ return `var deviceLicenseKeyIdentifier = "THIS_IDENTIFIER_WILL_DEPEND_ON_YOUR_DEVELOPER_ACCOUNT";
    
// Initialize the FaceTec SDK with your SDK Key
// @param - deviceLicenseKeyIdentifier - This is your Device SDK Key Identifier. You can get your Device SDK Key Identifier here: https://dev.facetec.com/zoomsdk/#/account
// @param - initializationSuccessful -  Optional callback to notify caller when FaceTec SDK initialization has completed
//
ZoomSDK.initialize(deviceLicenseKeyIdentifier, function(initializationSuccessful) {
  console.log("ZoomSDK.initialize() success: " + initializationSuccessful + ". Current status: " + ZoomSDK.getStatus()); // Check ZoomSDK.getStatus() to get granular reason
});`};


// WEBPACK FOOTER //
// ./src/resources/code/quickstart/web/00-initialize-dev.js.tpl